import React from "react";
import ReactDOM from "react-dom/client";
import "./style.scss";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { initialState, reducer } from "./Context/Reducer";
import { StateProvider } from "./Context/StateProvider";
import { ChakraProvider } from "@chakra-ui/react";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "axios";

Axios.interceptors.request.use(
  function (config) {
    // document.body.classList.add(" ");
    var div1 = document.createElement("div");
    div1.setAttribute("class", "loaderBlock");
    div1.setAttribute("id", "healthLoader");
    var div2 = document.createElement("div");
    // div2.setAttribute("class", "pulse");
    div1.appendChild(div2);
    document.body.appendChild(div1);
    return config;
  },
  function (error) {
    // document.body.classList.remove(" ");
    const element = document.getElementById("healthLoader");
    element.remove();
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    // spinning hide
    const element = document.getElementById("healthLoader");
    element.remove();
    // document.body.classList.remove("loading-indicator");
    return response;
  },
  function (error) {
    // document.body.classList.remove("loading-indicator");
    const element = document.getElementById("healthLoader");
    element.remove();

    return Promise.reject(error);
  }
);


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ChakraProvider>
      <StateProvider initialState={initialState} reducer={reducer}>
        <App />
      </StateProvider>
    </ChakraProvider>
  </BrowserRouter>

  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
